<template>
    <div class="checkoutWrapper">
        <orderInvoice
            @openCartSidebar="$emit('openCartSidebar')"
            @routeChange="routeChange"
            :shippingInstructions="shippingInstructions"
            :packageBoxInstructions="packageBoxInstructions"
            :merchantDeliveryInstructions="merchantDeliveryInstructions"
            :pickupInstructions="pickupInstructions"
            :arrangementMethodInstructions="arrangementMethodInstructions"
            :userSingleOrder="userSingleOrder"
            :shopData="shopData"
            :totalAmount="totalAmount"
            :currentLang="currentLang"
        />

        <h2 style="margin-top: 45px; margin-bottom: 20px" v-if="!packageBoxActive && !courierDeliveryActive && !merchantDeliveryActive && !pickupActive && !arrangementActive">{{$t('checkoutPage.chooseMethod')}}</h2>

        <shippingProfile_alt_2 
            v-if="shippingProfileData && !packageBoxActive && !courierDeliveryActive && !merchantDeliveryActive && !pickupActive && !arrangementActive" 
            @selectMethod="selectMethod"
            :checkoutPage="true"
            :shippingProfileData="shippingProfileData" 
            :currentLang="currentLang"
        />
        <br>
        <parcelTerminalForm
            ref="parcelTerminalComp"
            id="packageBoxIns"
            @instructions="fetchInstructions"
            @confirmGuestInstructions="confirmGuestInstructions"
            @closeForm="closeForm"
            :legalEntity="legalEntity"
            :packageBoxActive="packageBoxActive"
            :packageBoxInstructions="packageBoxInstructions"
            :fullOrder="fullOrder"
            :shippingInstructions="shippingInstructions"
            :guestOrderConfirmed="guestOrderConfirmed"
            :userGroups="userGroups"
            :error="errorMessage"
            :idShop="idShop"
            :currentLang="currentLang"
        />

        <courierDeliveryForm
            ref="courierDeliveryComp"
            id="courierDeliveryIns"
            @instructions="fetchInstructions"
            @confirmGuestInstructions="confirmGuestInstructions"
            @closeForm="closeForm"
            :shippingProfile="shippingProfileData"
            :legalEntity="legalEntity"
            :courierDeliveryActive="courierDeliveryActive"
            :courierDeliveryInstructions="courierDeliveryInstructions"
            :fullOrder="fullOrder"
            :shippingInstructions="shippingInstructions"
            :guestOrderConfirmed="guestOrderConfirmed"
            :userGroups="userGroups"
            :error="errorMessage"
            :idShop="idShop"
            :currentLang="currentLang"
        />

        <merchantDeliveryForm
            ref="merchantDeliveryComp"
            id="merchantDeliveryIns"
            @instructions="fetchInstructions"
            @confirmGuestInstructions="confirmGuestInstructions"
            @closeForm="closeForm"
            :legalEntity="legalEntity"
            :shippingProfile="shippingProfileData"
            :merchantDeliveryActive="merchantDeliveryActive"
            :merchantDeliveryInstructions="merchantDeliveryInstructions"
            :fullOrder="fullOrder"
            :shippingInstructions="shippingInstructions"
            :guestOrderConfirmed="guestOrderConfirmed"
            :userGroups="userGroups"
            :error="errorMessage"
            :idShop="idShop"
            :currentLang="currentLang"
        />

        <pickupPointsForm
            ref="pickupComp"
            @instructions="fetchInstructions"
            @confirmGuestInstructions="confirmGuestInstructions"
            @closeForm="closeForm"
            :legalEntity="legalEntity"
            :shippingProfile="shippingProfileData"
            :pickupActive="pickupActive"
            :pickupInstructions="pickupInstructions"
            :fullOrder="fullOrder"
            :shippingInstructions="shippingInstructions"
            :guestOrderConfirmed="guestOrderConfirmed"
            :userGroups="userGroups"
            :error="errorMessage"
            :idShop="idShop"
            :currentLang="currentLang"
        />

        <arrangementForm
            ref="arrangementComp"
            @instructions="fetchInstructions"
            @confirmGuestInstructions="confirmGuestInstructions"
            @closeForm="closeForm"
            :legalEntity="legalEntity"
            :shippingProfile="shippingProfileData"
            :arrangementActive="arrangementActive"
            :arrangementMethodInstructions="arrangementMethodInstructions"
            :fullOrder="fullOrder"
            :shippingInstructions="shippingInstructions"
            :guestOrderConfirmed="guestOrderConfirmed"
            :userGroups="userGroups"
            :error="errorMessage"
            :idShop="idShop"
            :currentLang="currentLang"
        />
        <div class="confirmEmail" v-if="guestOrderConfirmed">
            <h3 style="color: rgb(175,175,175)">{{activeMethod}}</h3>
            <!-- <img 
                :src="require('@/assets/icons/dashboard/order/email.svg')"
            /> -->
            <h2>{{$t('checkoutPage.confirmOrder')}}</h2>
            <p>{{$t('checkoutPage.confirmOrderText')}}</p>
            <p><b>{{guestOrder.email}}</b></p>
            <!-- <img class="backgroundIllustrationEmail" :src="require('@/assets/illustrations/elements/fowardLinkIll.svg')"/> -->
        </div>

        <p class="termsError" v-if="!guestOrderConfirmed && isUserFromGroup('guest') && shippingInstructions != '' && termsError">{{$t('checkoutPage.termsError')}}</p>

        <p class="checkboxInput" v-if="!guestOrderConfirmed && isUserFromGroup('guest') && shippingInstructions != ''">
            <input type="checkbox" @click="termsError = false" id="terms" v-model='acceptTerms'/>
            <label class="disclaimerText" for="terms" style="color: rgb(100,100,100)"></label>
            <a>{{$t('checkoutPage.terms.confirm')}} <span>{{$t('checkoutPage.terms.user')}}</span> {{$t('checkoutPage.terms.and')}} <span>{{$t('checkoutPage.terms.privacy')}}</span></a>
        </p>

        <div class="payBtn" v-if="!guestOrderConfirmed && shippingInstructions != ''">
            <Button 
                class="p-button-outlined"
                :label="$t('checkoutPage.buttons.change')" 
                @click="deleteTransport"
                style="width: 43%; border-radius: 10px;"
            />
            <Button 
                :label="$t('checkoutPage.buttons.formalize')" 
                @click="formalize" 
                style="width: 55%; border-radius: 10px;"
            />
        </div>
    </div>
</template>

<script>
import orderInvoice from '@kristjan87/storium-shop-library/src/components/main/checkout/invoice/invoice.vue';
import shippingProfile_alt_2 from '@kristjan87/storium-shop-library/src/components/main/shop/shipping/profile_alt_2/profile_alt_2.vue';

import parcelTerminalForm from '@kristjan87/storium-shop-library/src/components/main/checkout/shippingInstructions/forms/parcelTerminal.vue';
import courierDeliveryForm from '@kristjan87/storium-shop-library/src/components/main/checkout/shippingInstructions/forms/courierDelivery.vue';
import merchantDeliveryForm from '@kristjan87/storium-shop-library/src/components/main/checkout/shippingInstructions/forms/merchantDelivery.vue';
import pickupPointsForm from '@kristjan87/storium-shop-library/src/components/main/checkout/shippingInstructions/forms/pickupPoints.vue';
import arrangementForm from '@kristjan87/storium-shop-library/src/components/main/checkout/shippingInstructions/forms/arrangement.vue';

import shippingInstructions from '../apiFetches(old)/shippingInstructions'
import singleOrder from '../apiFetches(old)/singleOrder'

import Button from 'primevue/button';

export default {
    name: 'checkoutPage',
    components: {
        Button,
        orderInvoice,
        shippingProfile_alt_2,

        parcelTerminalForm,
        courierDeliveryForm,
        merchantDeliveryForm,
        pickupPointsForm,
        arrangementForm,
    },
    watch: {
        shippingProfileData: {
            handler(newVal) {
                if (newVal) {
                    this.setShippingProfileMethods();
                }
            },
            immediate: true, // Executes the watcher immediately on component creation
            deep: true // Watches the nested properties if needed
        },
        cartContentChange: {
            handler(newVal) {
                if (newVal) {
                    this.orderDataFetch();
                }
            },
        }
    },
    props: {
        idShop: {},
        shopData: {},
        shippingProfileData: {},
        userGroups: null,
        cartContentChange: null,
        currentLang: String
    },
    data() {
        return {
            catchError: null,
            isLoading: false,

            idOrder: Number(this.$route.params.idOrder),
            fullOrder: '',
            idDeal: '',
            idListing: null,
            userSingleOrder: '',
            legalEntity: '',
            deliveryTime: null,

            guestOrderConfirmed: false,
            guestOrder: '',
            idShippingInstructions: '',
            idGuestOrder: '',

            acceptTerms: false,
            termsError: false,
            totalAmount: '',
            shippingMethods: [],
            overallErrors: '',
            errorMessage: '',
            packageBoxMethod: false,
            pickUpMethod: false,
            sellerDeliveryMethod: false,
            arrangementMethod: false,
            courierDelivery: false,
            transConfirmed: null,
            activeMethod: null,

            packageBoxActive: false,
            pickupActive: false,
            merchantDeliveryActive: false,
            arrangementActive: false,
            courierDeliveryActive: false,

            shippingInstructions: '',
            packageBoxInstructions: false,
            pickupInstructions: false,
            merchantDeliveryInstructions: false,
            arrangementMethodInstructions: false,
            courierDeliveryInstructions: false,

            parcelTerminalData: null,
            merchantDeliveryData: null,
            pickupMethodData: null,
            arrangementMethodData: null,
            courierDeliveryData: null,

            omniva: false,
            smartPost: false,
            dpd: false,

            scroll: 0,
        };
    },
    methods: {
        routeChange(pageName, idEntity) {
            if(pageName == 'checkoutPage') {
                this.$router.push({ name: pageName, params: { idOrder: idEntity } })
            }
            if(pageName == 'catalogPage') {
                this.$router.push({ name: pageName, params: { id: idEntity } })
            }
        },

        round(num, decimalPlaces = 0) {
            num = Math.round(num + "e" + decimalPlaces);
            return Number(num + "e" + -decimalPlaces);
        },

        closeForm() {
            this.packageBoxActive = false
            this.pickupActive = false
            this.merchantDeliveryActive = false
            this.arrangementActive = false
            this.courierDeliveryActive = false
        },

        selectMethod(method) {
            if(method == 'parcelTerminal') {
                this.packageBox()
            }
            if(method == 'merchantDelivery') {
                this.sellerDelivery()
            }
            if(method == 'pickupMethod') {
                this.pickup()
            }
            if(method == 'arrangementMethod') {
                this.arrangementF()
            }
            if(method == 'courierDelivery') {
                this.courierDeliveryFnc()
            }
        },

        setShippingProfileMethods() {
            this.shippingMethods = this.shippingProfileData.shippingMethods
            for(const element of this.shippingMethods) {
                if(element.shippingOption === 'merchantDelivery') {
                    this.sellerDeliveryMethod = true
                    this.merchantDeliveryData = element.attr
                    setTimeout(() => {
                        this.$refs.merchantDeliveryComp.merchantAddress = element.attr.address.addressAsString
                        this.$refs.merchantDeliveryComp.merchantDelivery = element
                    }, 1);
                }
                if(element.shippingOption === 'pickupMethod') {
                    this.pickUpMethod = true
                    this.pickupMethodData = element.attr
                    setTimeout(() => {
                        this.$refs.pickupComp.pickupDelivery = element
                    }, 1);
                }
                if(element.shippingOption === 'parcelTerminal') {
                    this.packageBoxMethod = true
                    this.parcelTerminalData = element.attr
                    setTimeout(() => {
                        this.$refs.parcelTerminalComp.parcelOptions(this.shippingProfileData)
                    }, 1);
                }
                if(element.shippingOption === 'arrangementMethod') {
                    this.arrangementMethod = true
                    this.arrangementMethodData = element.attr
                    setTimeout(() => {
                        this.$refs.arrangementComp.arrangement = element
                    }, 1);
                }
                if(element.shippingOption === 'courierDelivery') {
                    this.courierDelivery = true
                    this.courierDeliveryData = element.attr
                    setTimeout(() => {
                        this.$refs.courierDeliveryComp.courierDelivery = element
                    }, 1);
                }
            }
            if(this.packageBoxMethod) {
                for(const element of this.parcelTerminalData.supportedParcelTerminals) {
                    if(element.name === 'Omniva') {
                        this.omniva = true
                    }
                    if(element.name === 'SmartPost') {
                        this.smartPost = true
                    }
                    if(element.name === 'DPD') {
                        this.dpd = true
                    }
                }
            }
        },

        loadLegalEntity(ref) {
            fetch(this.$fetchIp+'/v2/legal-entity/user/'+this.idUser, {
                method: 'GET',
                headers: {
                    'Content-type':'application/json'
                },
                credentials: 'include',
            }) 
            .then((res) =>  res.json())
            .then((res) => {
                if(res.data.legalEntity) {
                    const data = res.data.legalEntity
                    this.legalEntity = data
                    
                    setTimeout(() => {
                        if(ref == 'parcelTerminal') {
                            this.$refs.parcelTerminalComp.loadLegalEntity()
                        }
                        if(ref == 'merchantDelivery') {
                            this.$refs.merchantDeliveryComp.loadLegalEntity()
                        }
                        if(ref == 'pickup') {
                            this.$refs.pickupComp.loadLegalEntity()
                        }
                        if(ref == 'agreement') {
                            this.$refs.arrangementComp.loadLegalEntity()
                        }
                        if(ref == 'courierDelivery') {
                            this.$refs.courierDeliveryComp.loadLegalEntity()
                        }
                    }, 100)
                }
            })
        },

        insertLegalEntity(ref) {
            setTimeout(() => {
                if(ref == 'parcelTerminal') {
                    this.$refs.parcelTerminalComp.loadLegalEntity()
                }
                if(ref == 'merchantDelivery') {
                    this.$refs.merchantDeliveryComp.loadLegalEntity()
                }
                if(ref == 'pickup') {
                    this.$refs.pickupComp.loadLegalEntity()
                }
                if(ref == 'agreement') {
                    this.$refs.arrangementComp.loadLegalEntity()
                }
                if(ref == 'courierDelivery') {
                    this.$refs.courierDeliveryComp.loadLegalEntity()
                }
            }, 100)
        },

        loadLocalstorageLegalEntity(ref) {
            const legalEntity = localStorage.getItem('legalEntity')
            let dataObj = JSON.parse(legalEntity)
            this.legalEntity = dataObj

            setTimeout(() => {
                if(ref == 'parcelTerminal') {
                    this.$refs.parcelTerminalComp.loadLegalEntity()
                }
                if(ref == 'merchantDelivery') {
                    this.$refs.merchantDeliveryComp.loadLegalEntity()
                }
                if(ref == 'pickup') {
                    this.$refs.pickupComp.loadLegalEntity()
                }
                if(ref == 'agreement') {
                    this.$refs.arrangementComp.loadLegalEntity()
                }
                if(ref == 'courierDelivery') {
                    this.$refs.courierDeliveryComp.loadLegalEntity()
                }
            }, 100)
        },

        packageBox() {
            this.packageBoxActive = true
            this.pickupActive = false
            this.merchantDeliveryActive = false
            this.arrangementActive = false
            this.courierDeliveryActive = false

            this.errorMessage = ''
            this.activeMethod = this.$t('checkoutPage.packageTerminal')
            if(this.legalEntity == '' && !this.isUserFromGroup('guest')) {
                this.loadLegalEntity('parcelTerminal')
            }
            if(this.legalEntity) {
                this.insertLegalEntity('parcelTerminal')
            }
            if(this.isUserFromGroup('guest')) {
                this.loadLocalstorageLegalEntity('parcelTerminal')
            }
            // setTimeout(() => {
            //     var el = document.querySelector(`#packageBoxIns`);
            //     window.scroll({top: el.offsetTop + this.scroll, behavior: 'smooth'});
            // }, 100)
        },

        pickup() {
            this.packageBoxActive = false
            this.pickupActive = true
            this.merchantDeliveryActive = false
            this.arrangementActive = false
            this.courierDeliveryActive = false

            this.errorMessage = ''
            this.activeMethod = this.$t('checkoutPage.pickupMethod')
            if(this.legalEntity == '' && !this.isUserFromGroup('guest')) {
                this.loadLegalEntity('pickup')
            }
            if(this.legalEntity) {
                this.insertLegalEntity('pickup')
            }
            if(this.isUserFromGroup('guest')) {
                this.loadLocalstorageLegalEntity('pickup')
            }
            // setTimeout(() => {
            //     var el = document.querySelector(`#pickupPointIns`);
            //     window.scroll({top: el.offsetTop + this.scroll, behavior: 'smooth'});
            // }, 100)
        },

        sellerDelivery() {
            this.packageBoxActive = false
            this.pickupActive = false
            this.merchantDeliveryActive = true
            this.arrangementActive = false
            this.courierDeliveryActive = false

            this.errorMessage = ''
            this.activeMethod = this.$t('checkoutPage.merchantDelivery')
            if(this.legalEntity == '' && !this.isUserFromGroup('guest')) {
                this.loadLegalEntity('merchantDelivery')
            }
            if(this.legalEntity) {
                this.insertLegalEntity('merchantDelivery')
            }
            if(this.isUserFromGroup('guest')) {
                this.loadLocalstorageLegalEntity('merchantDelivery')
            }
            // setTimeout(() => {
            //     var el = document.querySelector(`#merchantDeliveryIns`);
            //     window.scroll({top: el.offsetTop + this.scroll, behavior: 'smooth'});
            // }, 100)
        },

        courierDeliveryFnc() {
            this.packageBoxActive = false
            this.pickupActive = false
            this.merchantDeliveryActive = false
            this.arrangementActive = false
            this.courierDeliveryActive = true

            this.errorMessage = ''
            this.activeMethod = this.$t('checkoutPage.courierDelivery')
            if(this.legalEntity == '' && !this.isUserFromGroup('guest')) {
                this.loadLegalEntity('courierDelivery')
            }
            if(this.legalEntity) {
                this.insertLegalEntity('courierDelivery')
            }
            if(this.isUserFromGroup('guest')) {
                this.loadLocalstorageLegalEntity('courierDelivery')
            }
            // setTimeout(() => {
            //     var el = document.querySelector(`#courierDeliveryIns`);
            //     window.scroll({top: el.offsetTop + this.scroll, behavior: 'smooth'});
            // }, 100)
        },
        
        arrangementF() {
            this.packageBoxActive = false
            this.pickupActive = false
            this.merchantDeliveryActive = false
            this.arrangementActive = true
            this.courierDeliveryActive = false

            this.errorMessage = ''
            this.activeMethod = this.$t('checkoutPage.arrangementMethod')
            if(this.legalEntity == '' && !this.isUserFromGroup('guest')) {
                this.loadLegalEntity('agreement')
            }
            if(this.legalEntity) {
                this.insertLegalEntity('agreement')
            }
            if(this.isUserFromGroup('guest')) {
                this.loadLocalstorageLegalEntity('agreement')
            }
            // setTimeout(() => {
            //     var el = document.querySelector(`#arrangementIns`);
            //     window.scroll({top: el.offsetTop + this.scroll, behavior: 'smooth'});
            // }, 100)
        },

        orderDataFetch() {
            if(this.idOrder != 0) {
                singleOrder(this.idOrder)
                .then((res) => {
                    this.fullOrder = res.data.order
                    this.totalAmount  = res.data.order.totalAmount
                    this.userSingleOrder = res.data.order.listings
        
                    let times = []
                    for(const element of this.userSingleOrder) {
                        times.push(element.deliveryTime)
                    }
                    this.deliveryTime = Math.max.apply(null, times)
                    this.idListing = res.data.order.listings[0].idListing
                    if(this.fullOrder.idShippingInstructions != null) {
                        this.fetchInstructions(this.fullOrder.idShippingInstructions)
                    }
                })
            } else {
                const order = localStorage.getItem('guestOrder')
                let arr = JSON.parse(order)

                if(arr.length > 0) {
                    for(const element of arr) {
                        if(element.idShop == this.idShop) {
                            if(element.listings.length > 0) {
                                this.fullOrder = element
                                this.totalAmount  = this.round(this.fullOrder.listings.reduce((a, b) => +a + +b.price * b.qty, 0), 2)
                                this.userSingleOrder = element.listings
                                this.idListing = element.listings[0].idListing
                                let times = []
                                for(const element of this.userSingleOrder) {
                                    times.push(element.attr.deliveryTime)
                                }
                                this.deliveryTime = Math.max.apply(null, times)
                            } else {
                                this.$router.push({name: 'catalogPage'})
                            }
                        }
                    }
                } else {
                    this.$router.push({name: 'catalogPage'})
                }
            }
        },

        fetchInstructions(idShippingInstructions) {
            shippingInstructions(idShippingInstructions)
            .then((res) => {
                if(res.data) {
                    this.transConfirmed = true
                    this.shippingInstructions = res.data.shippingInstructions
                    const idMethod = res.data.shippingInstructions.idShippingMethod
                    for(const element of this.shippingMethods) {
                        if(element.idShippingMethod === idMethod) {
                            const shippingOption = element.shippingOption
                            if(shippingOption === 'merchantDelivery') {
                                this.merchantDeliveryInstructions = true
                                this.activeMethod = this.$t('checkoutPage.merchantDelivery')
                            }
                            if(shippingOption === 'pickupMethod') {
                                this.pickupInstructions = true
                                this.activeMethod = this.$t('checkoutPage.pickupMethod')
                            }
                            if(shippingOption === 'parcelTerminal') {
                                this.packageBoxInstructions = true
                                this.activeMethod = this.$t('checkoutPage.packageTerminal')
                            }
                            if(shippingOption === 'arrangementMethod') {
                                this.arrangementMethodInstructions = true
                                this.activeMethod = this.$t('checkoutPage.arrangementMethod')
                            }
                            if(shippingOption === 'courierDelivery') {
                                this.courierDeliveryInstructions = true
                                this.activeMethod = this.$t('checkoutPage.courierDelivery')
                            }
                        }
                    }
                }
            })
        },
        confirmGuestInstructions(transportMethod, body) {
            this.guestOrder = body

            fetch(this.$fetchIp+'/v2/order/guest', {
            method: 'POST',
            headers: {
                'Content-type':'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(this.guestOrder)
            })
            .then((res) => res.json())
            .then((res => {
                if(res.status == 'success') {
                    this.transConfirmed = true
                    this.errorMessage = ''
                    this.idShippingInstructions = res.data.shippingInstructions.idShippingInstructions
                    this.idGuestOrder = res.data.order.idOrder
        
                    this.shippingInstructions = res.data.shippingInstructions
                    const idMethod = res.data.shippingInstructions.idShippingMethod
                    for(const element of this.shippingMethods) {
                        if(element.idShippingMethod === idMethod) {
                            const shippingOption = element.shippingOption
                            if(shippingOption === 'merchantDelivery') {
                                this.merchantDeliveryInstructions = true
                            }
                            if(shippingOption === 'pickupMethod') {
                                this.pickupInstructions = true
                            }
                            if(shippingOption === 'parcelTerminal') {
                                this.packageBoxInstructions = true
                            }
                            if(shippingOption === 'arrangementMethod') {
                                this.arrangementMethodInstructions = true
                            }
                            if(shippingOption === 'courierDelivery') {
                                this.courierDeliveryInstructions = true
                            }
                        }
                    }
    
                    this.$toast.add({ 
                        severity: 'success', 
                        summary: 'Tarne Kinnitatud!', 
                        detail: 'Järgmisena vormista tellimus tehinguks.', 
                        life: 5000 
                    });
                }
                switch(res.message) {
                    case 'Chosen parcel terminal provider is not a valid one.': {
                        this.errorMessage = 'Transpordi kinnitamiseks peate valima ühe pakiautomaadi tarnija'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Buyers note cannot exceed 700 characters.': {
                        this.errorMessage = `Lisamärkuste tekst on lubatust pikem (maks. 700 tähte [hetkel: ${res.data.currentLength} ])`
                        scrollTo(0, 700)
                        break
                    }
                    case 'Parcel terminal must be chosen.': {
                        this.errorMessage = 'Pakiautomaadi asukoht valimata.'
                        scrollTo(0, 700)
                        break
                    }
                    case "One listing's total volume is ten times greater than the volume of 10 largest boxes, consider a more realistic shipping method.": {
                        this.errorMessage = 'Pakiautomaadid ei ole reaalne tarnemeetod nii suure koguse tarnimiseks, proovige mõnda muud.'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Not very realistic to send products in more than 10 parcel terminal boxes. Please use a different method.': {
                        this.errorMessage = 'Pakiautomaadid ei ole reaalne tarnemeetod nii suure koguse tarnimiseks, proovige mõnda muud.'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Order contained a product which could not be fitted into any of the boxes.': {
                        this.errorMessage = 'Tellimuses on toode, mis ei mahu mitte ühegisse pakiautomaadi kastidesse.'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Total weight of the order exceeded the maximum allowed weight of the chosen parcel terminal provider.': {
                        this.errorMessage = 'Tellimuse kogukaal ületab maksimaalse lubatud kaalu, mida valitud pakiautomaat võimaldab.'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Must phone number of the consignee.': {
                        this.errorMessage = 'Sisestage telefoni number'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Consignee must provide a name.': {
                        this.errorMessage = 'Sisestage enda nimi'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Missing an address element.': {
                        this.errorMessage = 'Sisestage paki sihtkoha aadress(Veenduge, et kõik väljad oleksid täidetud)'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Total amount of the order must be more than the limit set for the specific shipping method.': {
                        this.errorMessage = 'Tellimuse summa peab olema suurem kui kaupleja määratud minimaalne väärtus(minimaalne: '+res.data.minOptionAmount+'€)'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Total amount of the order must be more than minimum order amount set by the shop.': {
                        this.errorMessage = 'Tellimuse väärtus peab olema suurema kui poe sätestatud minimaalne summa(minimaalne: '+res.data.minOrderAmount+'€)'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Distance is greater than is the largest set range up to which merchant delivers.': {
                        this.errorMessage = `Kaupleja ei tarni kaupa nii kaugele(Soovitud kaugus: ${res.data.travelDistanceInKm}km - Kaupleja maksimum: ${res.data.highestRange.range}km).`
                        scrollTo(0, 700)
                        break
                    }
                    case 'Error determining shipping cost.': {
                        this.errorMessage = 'Ilmnes viga, proovige hiljem uuesti või kontakteeruge kasutajatoega.'
                        scrollTo(0, 700)
                        break
                    }
                    case 'User must have a valid email.': {
                        this.errorMessage = 'Sisesta valiidne emaili aadress.'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Not a valid phone number.': {
                        this.errorMessage = 'Sisestatud telefoni number ei ole valiidne.'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Name contains forbidden characters.': {
                        this.errorMessage = 'Nimi sisaldab keelatud tähemärkke'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Something went wrong, please try again or contact support.': {
                        this.errorMessage = 'Nimi või telefoni number on sisestamata'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Name must be more than 4 characters.': {
                        this.errorMessage = 'Nimi peab olema rohkem kui 4 tähemärki'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Store is currently not open for orders.': {
                        this.errorMessage = `Pood ${this.fullOrder.shopName} ei ole hetkel tellimiseks avatud, proovige hiljem uuesti.`
                        scrollTo(0, 700)
                        break
                    }
                    case 'Pickup point id must be a valid cuid string.': {
                        this.errorMessage = 'Valige järgituleku punkt'
                        scrollTo(0, 700)
                        break
                    }
                    case 'Insufficient stock for listing': {
                        this.errorMessage = `Ühte toodet ei ole laos piisavalt järgi (Soovitud kogus: ${res.data.requested}, laoseis: ${res.data.remainingStock})`
                        scrollTo(0, 700)
                        break
                    }
                    case 'Shipment destination must have description.': {
                        if(this.courierDeliveryActive) {
                            this.errorMessage = `Sisesta sihtkoha aadress.`
                            scrollTo(0, 700)
                        } else {
                            this.errorMessage = `Kokkuleppe meetodil peab olema sisestatud lisainfo.`
                            scrollTo(0, 700)
                        }
                        break
                    }
                }
            }))
        },

        deleteTransport() {
            this.termsError = false
            if(!this.isUserFromGroup('guest')) {
                fetch(this.$fetchIp+'/v2/shipping/instructions/'+this.shippingInstructions.idShippingInstructions, {
                method: 'DELETE',
                headers: {
                    'Content-type':'application/json'
                },
                credentials: 'include',
                })
                .then((res) => res.json())
                .then((res) => {
                    if(res.status == 'success') {
                        // this.$track.customEvent('Tarnejuhised kustatud', 'orderProcess', 'transportInstructionsDeleted')
                    
                        this.$toast.add({ 
                            severity: 'warn', 
                            summary: 'Tarne tühistatud!', 
                            detail: '', 
                            life: 5000 
                        });
                        this.shippingInstructions = ''
                        this.merchantDeliveryInstructions = false
                        this.packageBoxInstructions = false
                        this.pickupInstructions = false
                        this.arrangementMethodInstructions = false
                        this.courierDeliveryInstructions = false
                    }
                })
            } else {
                // this.$track.customEvent('Tarnejuhised kustatud', 'orderProcess', 'transportInstructionsDeleted')
                
                this.$toast.add({ 
                    severity: 'warn', 
                    summary: 'Tarne tühistatud!', 
                    detail: '', 
                    life: 5000 
                });
                this.shippingInstructions = ''
                this.merchantDeliveryInstructions = false
                this.packageBoxInstructions = false
                this.pickupInstructions = false
                this.arrangementMethodInstructions = false
                this.courierDeliveryInstructions = false
            }
        },

        formalize() {
            if(this.isUserFromGroup("non-verified")) {
                this.$fire({
                    title: 'Ilma e-maili aadressi kinnitamata ei ole võimalik tellimust vormistada!',
                    text: 'Kinnitamist on võimalik algatada kasutaja seadete lehelt.',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Kasutaja seaded',
                    cancelButtonText: 'Tühista'
                }).then((res)=> {
                    if(res.value) {
                        this.$router.push({
                            'name': 'allSettings',
                            'params': {
                                'page': 'profiil'
                            }
                        })
                    }
                })
            } else {
                if(!this.isUserFromGroup('guest')) {
                    fetch(this.$fetchIp+'/v2/deal/formalize-order/'+this.idOrder, {
                        method: 'POST',
                        headers: {
                            'Content-type':'application/json'
                        },
                        credentials: 'include',
                    })
                    .then((res) => res.json())
                    .then((res) => {
                        if(res.message == 'Not possible to formalize an order without shipping instructions.') {
                            this.overallErrors = 'Enne vormistamist pead valima tarnemeetodi ja kinnitama transpordi'
                            scrollTo(0, 300)
                        } 
                        if(res.status == 'success') {
                            // this.$track.customEvent('Tellimus vormistatud', 'orderProcess', 'orderFormalizedCount')
                            this.idDeal = res.data.deal.idDeal
                            this.$router.push('/tellimus/maksmine/'+this.idOrder +'/'+this.idDeal)
                            
                            this.$toast.add({ 
                                severity: 'success', 
                                summary: 'Tellimus vormistatud!', 
                                detail: '', 
                                life: 5000 
                            });
                        } else {
                            this.overallErrors = 'Midagi läks valesti, proovige uuesti või kontakteeruge kasutajatoega'
                            scrollTo(0, 300)
                        }
                    })
                } else {
                    if(this.acceptTerms) {
                        this.termsError = false
                        this.guestOrder.isOrderConfirmed = true
                        fetch(this.$fetchIp+'/v2/order/guest', {
                            method: 'POST',
                            headers: {
                                'Content-type':'application/json'
                            },
                            credentials: 'include',
                            body: JSON.stringify(this.guestOrder)
                        })
                        .then((res) => res.json())
                        .then((res) => {
                            if(res.status == 'success') {
                                this.guestOrderConfirmed = true
        
                                const order = localStorage.getItem('guestOrder')
                                let obj = JSON.parse(order)
        
                                for(const [index, element] of obj.entries()) {
                                    if(this.idShop == element.idShop) {
                                        obj.splice(index, 1)
                                    }
                                }
        
                                let string = JSON.stringify(obj)
                                localStorage.setItem('guestOrder', string)
        
                                this.$emit("emitMenuReload")
                            }
                        })
                    } else {
                        this.termsError = true
                    }
                }
            }
        },

        isUserFromGroup(group) {
        if(this.userGroups.some(grupp => grupp === group)) {
            return true
        } else {
            return false
        }
    },

    },
    created() {
        this.orderDataFetch()
    },
};
</script>

<style scoped>
body {
    background: rgb(244, 244, 244);
    overflow-x: hidden;
    background-size: cover;
}
.checkoutWrapper {
    padding-top: 0px;
    padding-bottom: 20px;
}
.checkboxInput {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 15px;
    margin-bottom: 20px;
    margin-left: 0px;
    width: 480px;
}
.checkboxInput a {
    font-size: .9rem;
    margin: 0;
    padding-top: 2px;
    margin-left: 35px;
}
.checkboxInput span {
    color: steelblue;
    cursor: pointer;
    text-decoration: underline;
}
[type="checkbox"]:not(:checked),
[type="checkbox"]:checked {
    position: absolute;
    left: -9999px;
}
[type="checkbox"]:not(:checked) + label,
[type="checkbox"]:checked + label {
    position: relative;
    padding-left: 0px;
    margin-bottom: 0px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
}
.disclaimerText {
    height: 0;
    margin: 0;
}
/* checkbox aspect */
[type="checkbox"]:not(:checked) + label:before,
[type="checkbox"]:checked + label:before {
    content: '';
    position: absolute;
    left: 0px; top: 0px;
    width: 22px; height: 22px;
    border: 2px solid #d8d8d8;
    background: #fdfdfd;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 3px rgba(0,0,0,.1);
            box-shadow: inset 0 1px 3px rgba(0,0,0,.1);
}
/* checked mark aspect */
[type="checkbox"]:not(:checked) + label:after,
[type="checkbox"]:checked + label:after {
    content: '✔';
    position: absolute;
    top: -2px; left: 4px;
    font-size: 23px;
    line-height: 1.2;
    color: #09ad7e;
    -webkit-transition: all .2s;
    -o-transition: all .2s;
    transition: all .2s;
}
/* checked mark aspect changes */
[type="checkbox"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
        -ms-transform: scale(0);
            transform: scale(0);
}
[type="checkbox"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
        -ms-transform: scale(1);
            transform: scale(1);
}
/* disabled checkbox */
[type="checkbox"]:disabled:not(:checked) + label:before,
[type="checkbox"]:disabled:checked + label:before {
    -webkit-box-shadow: none;
            box-shadow: none;
    border-color: #999999;
    background-color: #dddddd;
}
[type="checkbox"]:disabled:checked + label:after {
    color: #999999;
}
[type="checkbox"]:disabled + label {
    color: #aaaaaa;
}
/* accessibility */
[type="checkbox"]:checked:focus + label:before,
[type="checkbox"]:not(:checked):focus + label:before {
    border: 2px solid #30acaa;
}
.confirmEmail {
    overflow: hidden;
    position: relative;
    text-align: center;
    width: 100%;
    margin-top: 0px;
    margin-bottom: 50px;
    padding-top: 35px;
    padding-bottom: 45px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 30px;
    background: white;
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.13);
            box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.13);
    border: 1px solid rgb(235,235,235);
}
.confirmEmail h2 {
    color: #64C3A2;
    text-align: center;
    font-size: 2.5rem;
}
.confirmEmail h3 {
    position: absolute;
    left: 25px;
    top: 0px;
    color: rgb(70, 70, 70);
    font-size: 1.3rem;
}
.confirmEmail p {
    width: 50%;
    margin: 15px auto;
    color: rgb(70, 70, 70);
    font-size: 1.3rem;
}
.payBtn {
    position: relative;
    width: 480px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    margin-bottom: 50px;
}

@media (max-width: 1335px) {
    .checkoutWrapper {
        padding-left: 20px;
        padding-right: 20px;
    }
}
@media (max-width: 730px) {
    .confirmEmail p {
        width: 100%;
    }
}
@media (max-width: 530px) {
    .payBtn {
        width: 100%;
    }
    .checkboxInput {
        width: 100%;
    }
    .confirmEmail {
        text-align: left;
        width: 100%;
        margin-top: 25px;
        margin-bottom: 30px;
        padding-top: 30px;
        padding-bottom: 25px;
        padding-left: 0px;
        padding-right: 0px;
        border-radius: 0px;
        background: transparent;
        -webkit-box-shadow: none;
                box-shadow: none;
        border: none;
    }
    .confirmEmail h2 {
        text-align: left;
        font-size: 24px;
    }
    .confirmEmail h3 {
        position: absolute;
        left: 15px;
    }
    .confirmEmail p {
        font-size: 1.2rem;
    }
}
</style>
